/* Cheryl Renée shared helpers: overlays (drawers / modals), focus trap, cart API, money.
   Ported from the mockup's setPanel() + Escape handler (design/mockup-source/script.js:123-131, 368-375). */
(function () {
  if (window.CR) return;
  var root = document.documentElement;
  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), iframe';
  // Escape closes the top-most overlay in the mockup's priority order.
  var ESC_ORDER = ['popup', 'quickview', 'search', 'cart', 'menu'];
  var open = {}; // kind -> overlay record

  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function focusables(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), visible);
  }

  function syncScrollLock() {
    root.classList.toggle('cr-no-scroll', Object.keys(open).length > 0);
  }

  // Tab cycles through the overlay's own focusable list in every browser. (Letting the browser move focus fails in
  // Safari/WebKit: it skips links and, after the last button, sends focus to the browser UI without any event.)
  function onTrapKeydown(event) {
    if (event.key !== 'Tab') return;
    var rec = this;
    var items = focusables(rec.box);
    event.preventDefault();
    if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    for (var n = 0; n < items.length; n++) {
      if (event.shiftKey) i = i <= 0 ? items.length - 1 : i - 1;
      else i = (i === -1 || i === items.length - 1) ? 0 : i + 1;
      items[i].focus();
      if (document.activeElement === items[i]) return; // skip anything the browser refuses to focus
    }
  }

  /**
   * Open an overlay. el gets .is-open + aria-hidden=false (mockup classes ported as .is-open).
   * opts: kind (escape priority key), box (element to trap focus in), trigger (gets aria-expanded),
   *       focus (selector to focus, default first .cr-icon-btn as in the mockup), onClose(cb)
   */
  // Order overlays were opened in; the last one owns focus.
  var stack = [];

  // Focus guard: Safari/WebKit skip links when tabbing (and clicks don't focus buttons), so the Tab-key trap alone
  // can be bypassed. Whenever focus lands outside the top-most open overlay, send it back inside.
  document.addEventListener('focusin', function (event) {
    var rec = open[stack[stack.length - 1]];
    if (!rec || rec.box.contains(event.target)) { if (rec) rec.lastInside = event.target; return; }
    var items = focusables(rec.box);
    if (!items.length) return;
    (rec.lastInside === items[0] ? items[items.length - 1] : items[0]).focus();
    // WebKit can refuse focus on links; make sure focus really is inside again.
    if (!rec.box.contains(document.activeElement)) items[0].focus();
  });

  function openOverlay(el, opts) {
    opts = opts || {};
    var kind = opts.kind || el.id;
    if (open[kind] && open[kind].el === el) return;
    var active = document.activeElement;
    // Safari doesn't focus a button on click; fall back to the trigger so focus can be restored on close.
    if ((!active || active === document.body) && opts.trigger) active = opts.trigger;
    var rec = { el: el, box: opts.box || el, trigger: opts.trigger || null, onClose: opts.onClose || null,
      lastFocus: active };
    rec.trap = onTrapKeydown.bind(rec);
    open[kind] = rec;
    stack = stack.filter(function (k) { return k !== kind; }).concat(kind);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (rec.trigger) rec.trigger.setAttribute('aria-expanded', 'true');
    rec.box.addEventListener('keydown', rec.trap);
    syncScrollLock();
    var target = el.querySelector(opts.focus || '.cr-icon-btn');
    if (target) setTimeout(function () { target.focus(); }, 60);
  }

  function closeOverlay(kind, opts) {
    var rec = open[kind];
    if (!rec) return;
    delete open[kind];
    stack = stack.filter(function (k) { return k !== kind; });
    rec.el.classList.remove('is-open');
    rec.el.setAttribute('aria-hidden', 'true');
    if (rec.trigger) rec.trigger.setAttribute('aria-expanded', 'false');
    rec.box.removeEventListener('keydown', rec.trap);
    syncScrollLock();
    if (!(opts && opts.restoreFocus === false) && rec.lastFocus && rec.lastFocus.focus && document.contains(rec.lastFocus)) rec.lastFocus.focus();
    if (rec.onClose) rec.onClose();
  }

  function isOpen(kind) { return !!open[kind]; }
  function anyOpen(kinds) { return (kinds || Object.keys(open)).some(function (k) { return !!open[k]; }); }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.dispatchEvent(new CustomEvent('cr:escape'));
    for (var i = 0; i < ESC_ORDER.length; i++) {
      if (open[ESC_ORDER[i]]) { closeOverlay(ESC_ORDER[i]); return; }
    }
  });

  /* ---------- Money (Shopify money_format) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Cart API ---------- */
  var routes = (function () {
    var el = document.querySelector('[data-cart-routes]');
    var r = { cartUrl: '/cart', cartAddUrl: '/cart/add', cartChangeUrl: '/cart/change' };
    try { if (el) r = Object.assign(r, JSON.parse(el.textContent)); } catch (e) {}
    return r;
  })();

  // Sections re-rendered with every cart change (registered by cr-cart-drawer + cr-header cart count).
  var cartSections = [];
  function registerCartSection(id) { if (id && cartSections.indexOf(id) === -1) cartSections.push(id); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status) {
          var err = new Error(json.description || json.message || 'Cart error');
          err.response = json;
          throw err;
        }
        return json;
      });
    });
  }

  function emitCart(detail) {
    document.dispatchEvent(new CustomEvent('cr:cart:updated', { detail: detail }));
    return detail;
  }

  function fetchCart() {
    return fetch(routes.cartUrl + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /** items: [{id, quantity, properties?}] */
  function addToCart(items) {
    var body = { items: items, sections: cartSections, sections_url: window.location.pathname };
    return postJSON(routes.cartAddUrl + '.js', body).then(function (res) {
      return fetchCart().then(function (cart) { return emitCart({ action: 'add', cart: cart, sections: res.sections || null, added: res.items || [res] }); });
    });
  }

  /** Re-read the cart and re-render the cart sections (used after adds made by other code, e.g. Debut's product form). */
  function refreshCart(action) {
    var sectionsReq = Promise.resolve(null);
    if (cartSections.length) {
      var u = new URL(window.location.pathname, window.location.origin);
      u.searchParams.set('sections', cartSections.join(','));
      sectionsReq = fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return Promise.all([fetchCart(), sectionsReq]).then(function (r) {
      return emitCart({ action: action || 'refresh', cart: r[0], sections: r[1] });
    });
  }

  function changeLine(key, quantity) {
    return postJSON(routes.cartChangeUrl + '.js', { id: key, quantity: quantity, sections: cartSections, sections_url: window.location.pathname })
      .then(function (cart) { return emitCart({ action: 'change', cart: cart, sections: cart.sections || null }); });
  }

  /** Replace an element's innerHTML from a Section Rendering API HTML string, matching by selector. */
  function swapFromHTML(html, selector, target) {
    if (!html || !target) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(selector);
    if (!src) return false;
    target.innerHTML = src.innerHTML;
    return true;
  }

  /** Fetch one section rendered in the context of a URL (Section Rendering API). */
  function renderSection(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Section render failed: ' + r.status);
      return r.text();
    });
  }

  /** Shopify section wrapper id ("shopify-section-<id>") → section id. */
  function sectionIdOf(el) {
    var wrap = el.closest('.shopify-section');
    return wrap ? wrap.id.replace(/^shopify-section-/, '') : null;
  }

  window.CR = {
    openOverlay: openOverlay,
    closeOverlay: closeOverlay,
    isOpen: isOpen,
    anyOpen: anyOpen,
    focusables: focusables,
    formatMoney: formatMoney,
    routes: routes,
    cart: { add: addToCart, change: changeLine, refresh: refreshCart, fetch: fetchCart, registerSection: registerCartSection },
    swapFromHTML: swapFromHTML,
    renderSection: renderSection,
    sectionIdOf: sectionIdOf,
    reducedMotion: function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  };
})();
